// maps
    // set global variables
    var gmarkers1 = [];
    var markers1 = [];
    var infowindow = new google.maps.InfoWindow({
        content: ''
    });
    let availableSellingPoints = [];
    let bounds = null;
    let results = [];
    var items = document.querySelector('.store_listing');

    if (items) {
      items = document.querySelector('.store_listing').getElementsByTagName('li');
    }

// Add markers (you can add as many as you like)
// Note, marker #5 has a lot of styling and an image in the info window. Just showing an example of what you can do with an info window.
markers1 = [
  ['0', '<div class="storeLocInfo"><span class="storePointName">ΝΑΥΤΙΛΟΣ ΑΛΙΜΟΥ</span><span class="storePointAddress">Λ. Ποσειδώνος 38Α - T.K. 17455 Aλιμος Αττικής</span><span class="storePointPhone">Τηλ: <span>210 9854238</span></span><span class="storePointEmail">info@nautilus.gr</span><span class="storePointWorkHours"><span class="storeWorkHoursTitle">ΩΡΑΡΙΟ ΛΕΙΤΟΥΡΓΙΑΣ</span><span>Καθημερινές 8:30 - 17:00</span><span>Σάββατο 09:00 - 15:00</span></span></span></div>', 37.9113504, 23.7109971, 'ΑΤΤΙΚΗ'],
  ['1', '<div class="storeLocInfo"><span class="storePointName">ΝΑΥΤΙΛΟΣ ΠΕΙΡΑΙΑ</span><span class="storePointAddress">Μαρίνα Ζέας - κατάστημα Β1-Β2 - Φρεαττύδα,ΤΚ 18536, Πειραιάς</span><span class="storePointPhone">Τηλ: <span>210 4283478</span></span><span class="storePointEmail">zea@nautilus.gr</span><span class="storePointWorkHours"><span class="storeWorkHoursTitle">ΩΡΑΡΙΟ ΛΕΙΤΟΥΡΓΙΑΣ</span><span>Καθημερινές 09:00 - 17:00</span><span>Σάββατο 09:00 - 15:00</span></span></span></div>', 37.9331017, 23.6450203, 'ΑΤΤΙΚΗ'],
  ['2', '<div class="storeLocInfo"><span class="storePointName">ΝΑΥΤΙΛΟΣ ΘΕΣΣΑΛΟΝΙΚΗΣ</span><span class="storePointAddress">Μαρίνα Ζέας - κατάστημα Β1-Β2 - Φρεαττύδα,ΤΚ 18536, Πειραιάς</span><span class="storePointPhone">Τηλ: <span>210 4283478</span></span><span class="storePointEmail">zea@nautilus.gr</span><span class="storePointWorkHours"><span class="storeWorkHoursTitle">ΩΡΑΡΙΟ ΛΕΙΤΟΥΡΓΙΑΣ</span><span>Καθημερινές 09:00 - 17:00</span><span>Σάββατο 09:00 - 15:00</span></span></span></div>', 40.574463982066064, 22.950114735484195, 'ΘΕΣΣΑΛΟΝΙΚΗ'],
  ['3', '<div class="storeLocInfo"><span class="storePointName">ΝΑΥΤΙΛΟΣ ΛΑΥΡΙΟΥ</span><span class="storePointAddress">Olympic Marine - 77χιλ. Αθηνών Σουνίου 19500 - Πάνορμος Λαυρίου</span><span class="storePointPhone">Τηλ: <span>22920 69288</span><span class="storePointFax">22920 69289</span></span><span class="storePointEmail">efra@nautilus.gr</span><span>Εμμανουήλ Φραγκάκης</span><span class="storePointWorkHours"><span class="storeWorkHoursTitle">ΩΡΑΡΙΟ ΛΕΙΤΟΥΡΓΙΑΣ</span><span>Καθημερινές 09:00 - 19:00</span><span>Σάββατο 09:00 - 18:00</span></span></span></div>', 37.6973217, 24.0561727, 'ΑΤΤΙΚΗ'],
  ['4', '<div class="storeLocInfo"><span class="storePointName">ΝΑΥΤΙΛΟΣ ΚΕΡΚΥΡΑΣ</span><span class="storePointAddress">Χριστ. Κοντόκαλι ΤΚ 49100</span><span class="storePointPhone">Τηλ: <span>26610 90054</span></span><span class="storePointEmail">eath@nautilus.gr</span><span>Ελένη Αθανασοπούλου</span></span><span class="storePointWorkHours"><span class="storeWorkHoursTitle">ΩΡΑΡΙΟ ΛΕΙΤΟΥΡΓΙΑΣ</span><span>Καθημερινές 10:00 - 19:00</span><span>Σάββατο 10:00 - 18:00</span></span></span></div>', 39.6448994, 19.8515868, 'ΚΕΡΚΥΡΑ'],
  ['5', '<div class="storeLocInfo"><span class="storePointName">ΝΑΥΤΙΛΟΣ ΛΕΥΚΑΔΑΣ</span><span class="storePointAddress">Υπ. Κατωπόδη & Σ. Τσέγιου, ΤΚ 31100</span><span class="storePointPhone">Τηλ: <span>26450 22365</span></span><span class="storePointEmail">roula@nautilus.gr</span><span>Ρούλα Κίρκου</span></span><span class="storePointWorkHours"><span class="storeWorkHoursTitle">ΩΡΑΡΙΟ ΛΕΙΤΟΥΡΓΙΑΣ</span><span>Καθημερινές 09:00 - 17:00</span><span>Σάββατο 09:00 - 15:00</span></span></span></div>', 38.8292218, 20.7044006, 'ΛΕΥΚΑΔΑ'],
  ['6', '<div class="storeLocInfo"><span class="storePointName">ΝΑΥΤΙΛΟΣ ΚΥΠΡΟΥ</span><span class="storePointAddress">Αλεξάνδρειας 4 Λεμεσός</span><span class="storePointPhone">Τηλ: <span>00357 25383832</span><span class="storePointFax">Fax: 00357 25212928</span></span><span class="storePointEmail">nautiluscy@cytanet.com.cy</span><span>Στέλλα Ανδρέου</span></span><span class="storePointWorkHours"><span class="storeWorkHoursTitle">ΩΡΑΡΙΟ ΛΕΙΤΟΥΡΓΙΑΣ</span><span>Δευτ,Τρίτ,Πέμπτ., Παρασκ. 08:00 - 16:00</span><span>Τετάρτη 08:00 - 13:00</span></span></span></div>', 34.6666488, 33.0229577, 'ΚΥΠΡΟΣ'],
  ['7', '<div class="storeLocInfo"><span class="storePointName">LOGISTIC CENTER - ΑΠΟΘΗΚΗ</span><span class="storePointAddress">Αγίας Άννης 97, Aγ. Ιωάννης Ρέντη, τκ. 18233</span><span class="storePointPhone">Τηλ: <span>210 3459719</span><span class="storePointFax">22920 69289</span></span><span class="storePointEmail">logistics@nautilus.gr</span><span class="storePointWorkHours"><span class="storeWorkHoursTitle">ΩΡΑΡΙΟ ΛΕΙΤΟΥΡΓΙΑΣ</span><span>Καθημερινές 09:00 - 17:30</span><span>Σάββατο Κλειστά</span></span></span></div>', 37.97183292213806, 23.680069015162264, 'ΑΤΤΙΚΗ'],
  ['8', '<div class="storeLocInfo"><span class="storePointName">ΝΑΥΤΙΛΟΣ ΡΟΔΟΥ</span><span class="storePointAddress">Αυστραλίας, Νέα Μαρίνα Ρόδος τκ. 85100</span><span class="storePointPhone">Τηλ: <span>22410 37111</span></span><span class="storePointEmail">rhodes@nautilus.gr</span><span class="storePointWorkHours"><span class="storeWorkHoursTitle">ΩΡΑΡΙΟ ΛΕΙΤΟΥΡΓΙΑΣ</span><span>Καθημερινές 09:00 - 16:00</span><span>Σάββατο 09:00 - 14:00</span></span></span></div>', 36.43403640057777, 28.237759600023253, 'ΡΟΔΟΣ']
];

// Function to init map
    function initialize() {
        var center = new google.maps.LatLng(38.1288311, 22.2387552);
        var mapOptions = {
            zoom: 6,
            center: center,
            mapTypeID: google.maps.MapTypeId.ROADMAP
        };
        map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
        for (i = 0; i < markers1.length; i++) {
            addMarker(markers1[i]);
        }
    }

    // Function to add markers to map
    function addMarker(marker) {
        var category = marker[4];
        var title = marker[1];
        var pos = new google.maps.LatLng(marker[2], marker[3]);
        var content = marker[1];

        marker1 = new google.maps.Marker({
            title: title,
            position: pos,
            category: category,
            map: map
        });
    gmarkers1.push(marker1);

    // Marker click listener (zoom in and open info window)
        google.maps.event.addListener(marker1, 'click', (function (marker1, content) {
            return function () {
                infowindow.setContent(content);
                infowindow.open(map, marker1);
                map.panTo(this.getPosition());
                map.setZoom(6);
            }
        })(marker1, content));
    }

    // Function to filter markers by category
    filterMarkers = function (category) {
      for (i = 0; i < markers1.length; i++) {
        var item = items[i];
        marker = gmarkers1[i];
            // If is same category or category not picked
            if (marker.category == category || category.length === 0) {
                marker.setVisible(true);
              item.classList.remove("storehidden");
            }
            // if Categories don't match
            else {
                marker.setVisible(false);
              item.classList.add("storehidden");
            }
        }
    }
    // Function to filter markers by category
    filterListrMarkers = function (category) {
      initialize()
        for (i = 0; i < markers1.length; i++) {
          // If is same category or category not picked
            if (marker.category == category || category.length === 0) {
                marker.setVisible(true);
            }
            // if Categories don't match
            else {
                marker.setVisible(false);
            }
        }
    }
    // Init map
    initialize();
    var input = document.querySelector('#storeSearch');
    var items = document.querySelector('.store_listing');
    if (items) {
      items = document.querySelector('.store_listing').getElementsByTagName('li');

    }
    input.addEventListener('keyup', function(ev) {
        var text = ev.target.value;
      const searchPlaceService = new google.maps.places.PlacesService(window.map)
      if (text){
        searchPlaceService.textSearch({
          location: new google.maps.LatLng({ lat: 38.1288311, lng: 22.2387552 }),
          radius: '1000km',
          query: text
        }, function (results, status) {
          if (status !== google.maps.places.PlacesServiceStatus.OK) { return }
          var sorted = sortSellingPointsByClosest(_.first(results).geometry.location);
          var filteredSorted =filteredSearchedClosestSellingPoints(sorted);
          updateMap(filteredSorted);
          results = filteredSorted.reduce(function (id, obj) {
            id.push(obj[0])
            return id
          }, [])
          for (var i=0; i < items.length; i++) {
            var item = items[i];
              item.classList.add("storehidden");
          }

          for (var i=0; i < items.length; i++) {
            var item = items[i];
            if (items[results[i]]) {
              items[results[i]].classList.remove("storehidden");
            }
          }
        })
      } else {
        initialize()
        results = [];
        var pat = new RegExp(text, 'i');
        for (var i=0; i < items.length; i++) {
          var item = items[i];
          if (pat.test(item.innerText)) {
            item.classList.remove("storehidden");
          }
          else {
            item.classList.add("storehidden");
          }
        }
      }


    });

    // count stores
    $('.store_listing li').each(function(){
        var number_selected = $('.store_listing li').length;
        $('.stores_filter_no span').empty();
        $('.stores_filter_no span').append(number_selected);
    })

    function sortSellingPointsByClosest (from) {
      const distances = []
      if (_.isEmpty(availableSellingPoints)) { availableSellingPoints = markers1 }
      for (const [i, sellingPoint] of Object.entries(availableSellingPoints)) {
        const to = new google.maps.LatLng({
          lat: sellingPoint[2] * 1.0,
          lng: sellingPoint[3] * 1.0
        })
        distances.push({
          sellingPoint: sellingPoint,
          distance: google.maps.geometry.spherical.computeDistanceBetween(from, to)
        })
      }
      return _.orderBy(distances, ['distance'], ['asc'])
    }

    function filteredSearchedClosestSellingPoints (closestSellingPoints) {
      const distancePoints = closestSellingPoints.reduce(function (points, obj) {
        if (obj.distance <= 200000){
          points.push(obj)
        }
        return points;
      },[])
  const closestPoints = _.map(distancePoints, distancePoints => distancePoints.sellingPoint)
  return closestPoints
}

function setMapAll (map) {
  $.each(gmarkers1, function (k, v) {
    v.setMap(map)
  })
}

  function updateMap(filteredSorted) {
    setMapAll(null)
    gmarkers1 = []
    bounds = new window.google.maps.LatLngBounds()
    const sellingPointsForBound = (!_.isEmpty(filteredSorted)) ? filteredSorted : markers1
    $.each(sellingPointsForBound, function (k, v) {
      bounds.extend({ lng: v[3] * 1.0, lat: v[2] * 1.0 })
    })
    bounds.extend({ lng: sellingPointsForBound[0][3]+0.05 * 1.0, lat: sellingPointsForBound[0][2]+0.05 * 1.0 })
    map = new google.maps.Map(document.getElementById('map-canvas'), {
      center: bounds.getCenter(),
      zoom: 8
    })
    map.fitBounds(bounds)
    for (i = 0; i < filteredSorted.length; i++) {
      addMarker(filteredSorted[i]);
    }
  }
